<template>
  <li class="li-item">
    <div class="userinfo">
      <img class="avatar" :src="item.avatar" />
      <span class="name">{{ item.author? item.author:'邻友' }}</span>
      <div class="supports"   @click="intoDownlyq">
        <img src="~@/assets/imgs/dz.png" class="dz">{{item.supports}}
      </div>
    </div>
    <div class="PLeft">
      <div class="content" v-html="item.message"></div>
      <div class="thrInfo" v-if="item.quote && (item.quote.rpid != item.firstRpid)">
        //@<span class="blue">{{
          item.quote.author?item.quote.author : '邻友'
          }}</span>
        <span class="thrMsg" v-html="item.quote.message"></span>
      </div>
      <div class="dateline">
        <button @click="onShowCommentReply" class="commentReply">回复</button> ·
        {{ item.dateline | momentDate }}
      </div>
      <!-- 回复时区分登录没登陆 -->
      <div class="textarea-box" v-if="item.showReply">
        <!-- 没登陆时 -->
        <div v-if="!areaUserInfo.username">
            <div @click="login">
              <div class="nologin_box">
                <p>请先<span>登录</span>后发表评论~</p>
              </div>
            </div>
        </div>
        <div v-else>
            <!-- 已登录 -->
          <el-form :model="form" ref="form">
            <el-form-item>
                <textarea v-model="form.content" :placeholder="`回复${item.author}`" rows="5" />
              </el-form-item>
              <el-form-item>
                <div class="submit-btn__box">
                  <button type="button" @click.prevent="onComment('form')" class="commentAction">评论</button>
                </div>
              </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 自定义渲染内容 slot -->
    <slot name="content" :row="item" :childLevel="level + 1" />
    <!-- 点击跳下载 -->

    <div class="descMask" v-show="intoDownloadLyq">
      <div class="maskBox">
          <div class="code" id="qrcode" ref="qrcode"></div>
          <div class="descTxt">邻友圈App或微信扫一扫参与互动</div>
            <div class="closeR" @click="closefoot"><img  src="@/assets/imgs/c2.png"></div>
      </div>
    </div>
  </li>
</template>

<script>
import {
    storageData
  } from "@/assets/js/storage";
  import bus from "../../utils/bus.js";
  import moment from "moment";
  import service from "@/api/service/service";
  import QRCode from 'qrcodejs2'
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      level: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        intoDownloadLyq:false,
        form: {
          content: ''
        },
        areaUserInfo: storageData.getUserInfo(),
      };
    },
    mounted() {
        this.$nextTick(()=>{
          this.qrcode()
        })
    },
    filters: {
      momentDate(date) {
        return moment(date * 1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {
      login(){//登录跳登录页
        this.$router.push({ path: `/arealogin?redirect=${this.$route.fullPath}` });
      },
      intoDownlyq(){
          this.intoDownloadLyq = true
      },
      closefoot(){
          this.intoDownloadLyq = false
      },
      qrcode() {
        let tid = this.$route.params.tid
        let qrcode = new QRCode(this.$refs.qrcode, {
          width: 200,
          height: 200,
          text: `https:${this.commonIp}/v1/threads/`+tid,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      onShowCommentReply() {
        console.log('================qwe8iur')
        bus.$emit("toggle-reply", this.item);
      },
      onComment(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            if (!this.form.content) {
              alert('请输入评论内容')
            } else {
              console.log(this.item)
              // 传的是回的谁，和回的内容
              this.$emit('spot', this.form.content, this.item);
              // this.form.content //将提交的内容传递给父组件
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        })
      },
    },
  };
</script>

<style lang="less" scoped>
//下载邻友圈弹窗
  .descMask{
			position: fixed;
			top:0;
			left:0;
			width:100%;
			height: 100%;
			background: rgba(0,0,0,.7);
			z-index: 9999;
			.maskBox{
				width:40%;
				padding:45px 35px;
				box-sizing: border-box;
				background:#fff;
				border-radius:5px;
				position: absolute;
				top: 40%;
				left: 50%;
				transform: translate(-50%, -40%);
				.close{
                    cursor: pointer;
					position: absolute;
					bottom:-36px;
					left:50%;
					width:20px;
					height: 20px;
					margin-left:-26px;
				}
				.txt{
					text-align: center;
					margin:0 0 20px 0;
				}
				.desc{
					font-size:15px;
					margin:0 0 10px 0;
					padding:0 0 0 30px;
					background:url("~@/assets/imgs/ts.png") no-repeat left center;
					background-size:10px 10px;
				}
                .wImg{
                    width: 200px;
                    margin: 20px 0;
                    text-align: center;
                    margin: 0 auto;
                    img{
                        display: block;
                        width: 200px;
                        height: 200px;
                        
                    }
                }
                .title{
                    margin:0 0 20px 0;
                    text-align: center;
                }
                .iknow{
                    color: #55aa7f;
                    cursor: pointer;
                    text-align: center;
                }
                .code{
                    width: 200px;
                    margin: 0 auto;
                    margin-bottom: 30px;
                    img{
                        width: 200px;
                        height: 200px;
                        display: block;
                    }
                }
                .descTxt{
                    margin: 10p 0;
                    font-size: 18px;
                    text-align: center;
                }
                .closeR{
                    position: absolute;
                    right: 15px;
                    top: 15px;
                    img{
                        display: block;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
			}
		}
  .li-item {
    border-bottom: 1px solid #f2f2f2; //每条评论加分隔
    padding: 10px 0;
    padding-left: 0px;

    .li-item {
      border-bottom: 0;
      padding-left: 50px;

      .li-item {
        padding-left: 0px;
      }
    }

    .thrInfo {
      display: inline;

      a {
        color: #436599;
      }
    }
  }

  .userinfo {
    width: 100%;
    padding: 10px 0;

    .supports {
      float: right;
      color: #999;
      margin-top: 5px;
      cursor: pointer;
      .dz {
        width: 20px;
        display: inline-block;
        margin: 0px 3px 0 0;
        vertical-align: middle;
      }
    }
  }

  .PLeft {
    width: 100%;
    padding-left: 50px;
    box-sizing: border-box;

    .blue {
      color: #436599;
    }

    .commentAction {
      cursor: pointer;
      margin-top: 10px;
      float: right;
      background-color: #505050;
      border-radius: 4px;
      width: 66px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      opacity: 0.3;

      &:hover {
        opacity: 0.2;
      }
    }

    .content {
      a {
        color: #436599;
      }
    }
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    vertical-align: middle;
  }

  .name {
    color: #436599;
    vertical-align: middle;
    margin-left: 10px;
  }

  .textarea-box {
    position: relative;
    background: #f2f3f5;
    .nologin_box{
      height: 146px;
      line-height: 146px;
      cursor: pointer;
      p{
        text-align: center;
        span{
          color: red;
          display: inline-block;
          margin: 0 5px;
        }
      }
    }
  }

  .submit-btn__box {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    padding: 10px;
    text-align: right;
    border: 1px solid #f2f2f2;
  }

  textarea {
    width: 100%;
    border: none;
    resize: none;
    outline: none;
    padding: 10px;
    background: #f2f2f2;
  }

  .content {
    padding: 5px 0;
    display: inline-block;
  }

  .dateline {
    padding: 5px 0;
    color: #999;
    font-size: 14px;

    .commentReply {
      font-size: 16px;
      cursor: pointer;
      background: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commentItem/commentItem.vue